import { useSelector } from "react-redux";
import useParam from "../../../../hooks/useParam";
import {
    MEDAL,
    MEDAL_TEAM_CANADA,
    NO_SELECTION,
    QUERY_PARAM_SPORT,
    TEAM_CANADA,
} from "./constants";

const useSport = (stateKey) => {
    const dropDownList = useSelector(
        (state) => state.schedule[stateKey]?.dropDownList
    );
    const validateSportParam = Array.isArray(dropDownList)
        ? (value) => dropDownList.some(({ mainKey }) => mainKey === value)
        : () => true;
    return useParam(QUERY_PARAM_SPORT, validateSportParam);
};

const useOlympics = () => {
    return parseInt(
        useParam("olympics", (value) =>
            [NO_SELECTION, MEDAL, TEAM_CANADA, MEDAL_TEAM_CANADA].includes(
                parseInt(value)
            )
        )
    );
};

const useMedal = () => {
    const olympics = useOlympics();
    return olympics === MEDAL || olympics === MEDAL_TEAM_CANADA;
};

const useTeamCanada = () => {
    const olympics = useOlympics();
    return olympics === TEAM_CANADA || olympics === MEDAL_TEAM_CANADA;
};

export const useFilterBarParams = (key) => {
    const type = useSport(key);
    const isMedal = useMedal();
    const isTeamCanada = useTeamCanada();
    return { type, isMedal, isTeamCanada };
};
